$(function() {
    $('body').on('click', '[data-popup]', function (event) {
        event.preventDefault();
        window.togglePopup($(this).data('popup'));
    });

    window.togglePopup = function (id) {
        const popup = $('#popup-' + id);
        if (!popup.length) {
            return;
        }
        window.body_scroll_position = $(window).scrollTop(); // huidige 'scroll' positie opslaan in een globale window variable
        popup.fadeIn('fast', 'linear', function () {
            $('body').css('position', 'fixed'); // ervoor zorgen dat de website (dus niet de modal maar de content achter de modal) niet meer gescrolled kan worden, vaak kan je op iOS Safari nog scrollen omdat de navigatiebar (onderaan het scherm) dan weggaat, dit houd dat tegen.
            $('body').css('overflow', 'hidden'); // ervoor zorgen dat de website (dus niet de modal maar de content achter de modal) niet meer gescrolled kan worden, vaak kan je op iOS Safari nog scrollen omdat de navigatiebar (onderaan het scherm) dan weggaat, dit houd dat tegen.
            popup.addClass('open');
        });
    };

    window.closePopup = function (id) {
        const popup = $('#popup-' + id);
        if (!popup.length) {
            return;
        }
        $('body').css('position', ''); // ervoor zorgen dat de website weer gescrolled kan worden
        $('body').css('overflow', ''); // ervoor zorgen dat de website weer gescrolled kan worden
        $(window).scrollTop(window.body_scroll_position); // 'scroll' positie terug zetten naar de waarde die het had voordat de popup geopend was
        popup.removeClass('open');
        popup.fadeOut();
    };

    window.closeAllPopups = function () {
        $('body').css('position', ''); // ervoor zorgen dat de website weer gescrolled kan worden
        $('body').css('overflow', ''); // ervoor zorgen dat de website weer gescrolled kan worden
        $(window).scrollTop(window.body_scroll_position); // 'scroll' positie terug zetten naar de waarde die het had voordat de popup geopend was
        const popups = $('.popup');
        popups.each(function () {
            $(this).fadeOut();
            $(this).removeClass('open');
        });
    };

    $('.popup__close__button').on('click', function (event) {
        event.preventDefault();
        window.closeAllPopups();
    });

    if (window.location.search.indexOf('popup') !== -1) {
        let params = new URLSearchParams(window.location.search);
        window.togglePopup(params.get('popup'));
    }

    $(document).on('keyup', function (event) {
        if (event.key === 'Escape' || event.keyCode === 27) {
            window.closeAllPopups();
        }
    });

    $('a[href^="?popup="]').each(function () {
        let popup = $(this).attr('href').replace('?popup=', '');
        $(this).attr('href', '#');
        $(this).attr('data-popup', popup);
    });
});
